import VideoTranscripts from "../../../common/videos/transcripts.js";
import InfoVideos4i from "./modules/infovideos.js";
import { InitCommon, ShowFromDialog, AddLinks } from "../shared.js";
import { mugImprintID } from "../../../common/videos/localized.js";

function init(){
    VideoTranscripts.init();
    InitCommon(VideoTranscripts);
    ShowFromDialog();
    if (window.location.hash != "#mugimprints"){
        InfoVideos4i.initWhyBuy();
    }

    document.addEventListener("click", clickEvents);
    setTimeout(() =>{ AddLinks(); }, 300);	
}

async function clickEvents(e) {
	const { target } = e;

	const actions = {
		whyBuyVideo: async (e) => {
            e.preventDefault();
			playWhyBuy();
		},
        mugImprintVideo: async (e) => {
            e.preventDefault();
            playMugImprint(e);
        }
	};
	
	if (actions[target.id]) {
		actions[target.id](e);
	}
}

function playWhyBuy(){   
    InfoVideos4i.initWhyBuy(true);
    showPlayer("Why Buy From Us");
}

function playMugImprint(){
    InfoVideos4i.initMugImprint(mugImprintID, true);
    showPlayer("Mug Imprints");
}

function showPlayer(vidTitle){
    VideoTranscripts.collapse();
    const vidTitleHeading = document.getElementById("playVidTitle");
    vidTitleHeading.innerHTML = vidTitle;
    updateTranscript();
}

function updateTranscript() {
    // wait for the transcript to be fetched and then update the height/whether to show button
    // will be triggered when the transcriptContainer element's children change
    const config = { childList: true, subtree: true };
    const callback = (mutationsList, observer) => {
        for (let i = 0; i < mutationsList.length; i++) {
            if (mutationsList[i].type === 'childList') {
                const vidContainer = document.getElementById("videoContainer");
                vidContainer.scrollIntoView({behavior: "smooth"});
                document.querySelector("#bitmovinplayer-video-player").focus();
                scriptObserver.disconnect();
                VideoTranscripts.getHeight();
            }
        }
    };
    const scriptObserver = new MutationObserver(callback);
    const transcriptDiv = document.getElementById("transcriptContainer");
    scriptObserver.observe(transcriptDiv, config);
}


init();